// extracted by mini-css-extract-plugin
export var root = "Text-module--root--7a9b3";